import React from 'react';
import Image from '../AppImage';
import Icon from '../AppIcon';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-4">
              <Image
                src="/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png"
                alt="CRF PERFECTION logo featuring interlocking heart-shaped design in red and gold colors representing Centre de Recherche et de Formation business therapy excellence"
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold">CRF PERFECTION</h3>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Cabinet international de formation, de conseil stratégique et de recherche appliquée, basé aux États-Unis, avec des agences en Afrique de l'Ouest (Bénin, Côte d'Ivoire, Togo).
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a href="tel:+12409784155" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <Icon name="Phone" size={14} />
                  <span>+1 (240) 978-4155</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@crfperfection.pro" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <Icon name="Mail" size={14} />
                  <span>contact@crfperfection.pro</span>
                </a>
              </li>
              <li className="text-gray-400 text-sm flex items-start space-x-2">
                <Icon name="MapPin" size={14} className="flex-shrink-0 mt-1" />
                <span>10411 Greenbelt road<br />Uperoom, MD, 20706</span>
              </li>
              <li>
                <a href="https://wa.me/12409784155" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <Icon name="MessageCircle" size={14} />
                  <span>WhatsApp: +1 (240) 978-4155</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Nos Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="/professional-training-services" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm">
                  Formations professionnelles
                </a>
              </li>
              <li>
                <a href="/conference-organization-services" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm">
                  Organisation de conférences
                </a>
              </li>
              <li>
                <a href="/strategic-consulting-services" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm">
                  Conseil stratégique
                </a>
              </li>
              <li>
                <a href="/research-studies-services" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm">
                  Études et recherches appliquées
                </a>
              </li>
            </ul>
          </div>

          {/* Social & Legal */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Réseaux & Légal</h4>
            <div className="space-y-3">
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <Icon name="Linkedin" size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <Icon name="Twitter" size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <Icon name="Facebook" size={20} />
                </a>
              </div>
              <div className="space-y-2">
                <a href="/privacy" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm block">
                  Politique de Confidentialité
                </a>
                <a href="/terms" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm block">
                  Conditions d'Utilisation
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-sm text-gray-500 mb-4 md:mb-0">
              © 2026 CRF Perfection – Cabinet International de Formation & Conseil. Tous droits réservés.
            </p>
            <div className="flex items-center space-x-4 text-sm text-gray-500">
              <a href="https://www.crfperfection.pro" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                www.crfperfection.pro
              </a>
            </div>
          </div>
          <div className="text-center mt-4">
            <p className="text-gray-500 text-sm">
              Bâtissons ensemble les compétences de demain.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;